module.exports = __webpack_public_path__ + "img/1.1dedcda2.png";